import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export enum EVerificationStatus {
  Unverified = 'Unverified',
  FinalVerified = 'Final verified',
  Verified = 'Verified',
  NeedsVerification = 'Needs verification',
  NeedsFinalVerification = 'Needs final verification',
  FinalVerificationInit = 'Final verification init',
  VerificationInit = 'Verification init',
  FinalVerificationChecking = 'Final verification checking',
  Checking = 'Checking',
  TryAgain = 'Try again',
  AccountIsBlocked = 'Account is blocked',
  LimitWithout2StepVerificationExceeded = 'Limit without 2-step verification exceeded',
  LimitWithoutVerificationExceeded = 'Limit without verification exceeded',
  FinalVerificationInProgress = 'Final verification in progress',
  VerificationInProgress = 'Verification in progress',
  TryVerificationAgain = 'Try verification again',
  EmailVerified = 'Email verified',
  YouAreVerified = 'You are verified!',
  CodeNotFoundOrHasExpired = 'Code not found or has expired!',
  YourEmailAddressIsNotVerified = 'Your email address is not verified.',
  EmailVerificationReturnedError = 'Email verification returned error!',
  TheNotificationWasSentAgain = 'The notification was sent again!',
}

export enum EVerificationStatusCode {
  KYC_STATUS_UNVERIFIED = 0,
  KYC_STATUS_VERIFIED = 1,
  KYC_STATUS_NEEDS_VERIFICATION = 2,
  KYC_STATUS_INIT = 3,
  KYC_STATUS_PROCESSING = 4,
  KYC_STATUS_RETRY = 5,
  KYC_STATUS_REJECT = 6,
  KYC_STATUS_PRIMARY_NEEDS_VERIFICATION = 7,
  KYC_STATUS_PRIMARY_INIT = 8,
  KYC_STATUS_PRIMARY_PROCESSING = 9,
  KYC_STATUS_PRIMARY_VERIFIED = 11,
  KYC_STATUS_PRIMARY_RETRY = 12,
  KYC_STATUS_PRIMARY_REJECT = 13,
}

export const ProfileDataResponseSchema = z
  .object({
    data: z.object({
      id: z.number(),
      firstname: z.string().nullable(),
      lastname: z.string().nullable(),
      avatar: z.string().nullable(),
      level: z.number(),
      dob: z.string().nullable(),
      email: z.string().nullable(),
      country: z.string().nullable(),
      timezone: z.string().nullable(),
      state: z.string().nullable(),
      city: z.string().nullable(),
      zip: z.string().nullable(),
      address1: z.string().nullable(),
      verification_status_code: z.number(),
      verification_status: z.nativeEnum(EVerificationStatus),
      wallet_locked_until: z.number().or(z.string()),
      is_2fa: z.number(),
      is_approved: z.boolean(),
      is_locked: z.number(),
      is_manager: z.number(),
      has_trial: z.boolean().optional(),
    }),
  })
  .transform(transformKeysToCamelCase);

export type TProfileDataResponse = z.infer<typeof ProfileDataResponseSchema>;
export type TProfileData = TProfileDataResponse['data'];
